import { ISingleProductPanelFields } from 'global';
import { useContentful } from 'modules/content-cms/components/context';
import ProductDetailsHeader from 'modules/product-details/components/product-details-header';
import { ProductDetailsHeaderProvider } from 'modules/product-details/components/product-details-header/state';
import React from 'react';
import ContentContainer from '../components/content-container';

type SingleProductPanelProps = ISingleProductPanelFields;

const SingleProductPanel: React.FC<SingleProductPanelProps> = ({
  productHandle,
  backgroundColor,
}) => {
  const { shopifyProductDetailMap } = useContentful();
  const productDetails = shopifyProductDetailMap[productHandle];

  if (!productDetails) {
    return <></>;
  }

  return (
    <ProductDetailsHeaderProvider productDetails={productDetails}>
      <ContentContainer
        backgroundColor={backgroundColor ? backgroundColor : 'white'}
        className="border-grey-300 container rounded-lg border"
      >
        <ProductDetailsHeader displayAsSection />
      </ContentContainer>
    </ProductDetailsHeaderProvider>
  );
};

export default SingleProductPanel;
